import React, { Component } from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class CustomCookieNotice extends Component {

	static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};

	constructor(props) {

		super(props)

	}

	closeNotice = () => {

		const { cookies } = this.props;

    	cookies.set('user-accepts-cookies', true, { path: '/' });

	}

	hasAcceptedCookies = () => {

		const { cookies } = this.props;

		return cookies.get('user-accepts-cookies');

	}

	render() {

		var hasAcceptedCookies = this.hasAcceptedCookies();

		if(hasAcceptedCookies) return null;

		return (

			<div className='cookiesNotice'>
				<div className="cookiesContent">
					<p>We use cookies to ensure that we give you the best experience on our website. By continuing to use this site you consent to the use of cookies on your device as described in our <OutboundLink href="/JBVC_Cookies_Policy_May_2018.pdf" target='_blank'>cookie policy</OutboundLink>. </p>
				</div>
                <div className="closeCookies" onClick={this.closeNotice} />
			</div>

		);

	}
}

export default withCookies(CustomCookieNotice)



// WEBPACK FOOTER //
// ./src/components/custom-cookie-notice.js